export const initialState = {
  data: [],
  errors: undefined,
  loading: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'eventFetch': {
      return { ...state, loading: true };
    }
    case 'eventFetchSuccess': {
      return { ...state, loading: false, data: action.payload };
    }
    case 'eventFetchError': {
      return { ...state, loading: true, errors: action.payload };
    }
    default: {
      return state;
    }
  }
}

export { reducer as eventReducer }